/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Dispatch, SetStateAction, useState } from "react";
import variablesScss from "../../Themes/variables.module.scss";

const breadcrumbMaxWidth = parseInt(variablesScss.breadcrumbMaxWidth, 10);

export default class BreadcrumbModel {
    private readonly _disableHoverListener: boolean;
    private readonly _setDisableHoverListener: Dispatch<SetStateAction<boolean>>;

    public constructor() {
        [this._disableHoverListener, this._setDisableHoverListener] = useState<boolean>(false);
    }

    public get disableHoverListener(): boolean {
        return this._disableHoverListener;
    }

    public readonly handleHoverListenerState = (element: HTMLElement | null) => {
        if (element) {
            this._setDisableHoverListener(breadcrumbMaxWidth > element.clientWidth);
        }
    };
}
